/* eslint-disable no-unused-vars */
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Icon from 'ui/Element/Icon'

/**
 * Intended to display a chevron for a cart.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellCartChevron = (classes, props = {}) => {
  const { chevronIcon } = props

  return (
    <Grid
      item
      container
      direction={'row-reverse'}
    >
      <Icon
        source={chevronIcon}
        color={'text.secondary'}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellCartChevron)
